import { Component } from '@angular/core';

@Component({
  selector: 'app-cards10-examples-68',
  templateUrl: './cards10-examples-68.component.html'
})
export class Cards10Examples68Component {}
